import { Line2 } from 'three/addons/lines/Line2.js';
import { LineMaterial } from 'three/addons/lines/LineMaterial.js';
import { LineGeometry } from 'three/addons/lines/LineGeometry.js';
import { pixelRatio2d } from '@/editor/math/const';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { disposeAllChildrenThenRemoveFromParent } from '../utils';
import { ENTITY_RENDER_ORDER, alignReferenceLineColor } from '@/editor/constant/entity';
import { EEntityType } from '@/editor/types';
import BaseModel2d from './BaseModel2d';
import { globalStores } from '@/editor/stores';
import { Vector3 } from 'three';

export class AlignLine extends BaseModel2d {
  private readonly _length = 2000;
  private _alignLine: Line2;

  constructor() {
    super();
    const lineGeometry = new LineGeometry();
    // 创建虚线材质
    const material = new LineMaterial({
      color: alignReferenceLineColor,
      linewidth: 1, // 宽度（单位：像素）
      dashed: true, // 启用虚线
      dashScale: 10, // 虚线缩放因子
      dashSize: 0.5, // 虚线段的长度
      gapSize: 0.25, // 间隔的长度
      transparent: true
    });

    this._alignLine = new Line2(lineGeometry, material);
    this._alignLine.userData.type = EEntityType.HighlightedLine;
    this._alignLine.visible = false;

    this._modelGroup.add(this._alignLine);
    this.setDisplayOrder(ENTITY_RENDER_ORDER.highlightedLine);
    globalStores.editorStateStore.sceneInfo.scene2d.scene.add(this._modelGroup);
  }

  get visible() {
    return this._alignLine.visible;
  }

  set visible(visible: boolean) {
    this._alignLine.visible = visible;
  }

  updateAdsorbLine(startPoint: IPoint2d, endPoint: IPoint2d) {
    const point1 = new Vector3(startPoint.x / pixelRatio2d, startPoint.y / pixelRatio2d, 0);
    const point2 = new Vector3(endPoint.x / pixelRatio2d, endPoint.y / pixelRatio2d, 0);
    // 计算方向向量
    const direction = new Vector3().subVectors(point2, point1).normalize();
    // 创建起点和终点
    const start = new Vector3().copy(point1).sub(direction.clone().multiplyScalar(this._length));
    const end = new Vector3().copy(point1).add(direction.clone().multiplyScalar(this._length));

    const points = [start, end];
    this._alignLine.geometry.setFromPoints(points);
    this._alignLine.computeLineDistances(); // 必须调用这个方法才能使虚线生效
  }

  override dispose() {
    disposeAllChildrenThenRemoveFromParent(this._modelGroup);
  }
}
